/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStandardBerechtigungenDto } from '../../models/lexplus-standard-berechtigungen-dto';

export interface StandardBerechtigungenControllerFindForKundeV1$Params {
}

export function standardBerechtigungenControllerFindForKundeV1(http: HttpClient, rootUrl: string, params?: StandardBerechtigungenControllerFindForKundeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStandardBerechtigungenDto>> {
  const rb = new RequestBuilder(rootUrl, standardBerechtigungenControllerFindForKundeV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStandardBerechtigungenDto>;
    })
  );
}

standardBerechtigungenControllerFindForKundeV1.PATH = '/v1/benutzerverwaltung/standard-berechtigungen';
